import { useEffect, useRef, useState } from 'react';
import './nav.css';
import BrazilAccentSVG from '../aboutUs/BrazilAccentSVG.jsx';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useAccount } from '../../contexts/accountContext';
import { useLocale } from 'src/components/aboutUs/LocaleContext';
import { useTranslation } from 'react-i18next';
import { Stack, useTheme, Tooltip, IconButton, Menu, MenuItem, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Badge, Divider, Typography, Box } from '@mui/material';
import { useCart } from 'src/contexts/cartContext';
import { useEvents } from 'src/contexts/eventsContext';
import { IoWalletOutline, IoTrashOutline, IoPersonSharp, IoCartOutline, IoClose, IoAdd, IoRemove, IoMenu, IoBarChartOutline } from 'react-icons/io5';
// Import SVG as URL; if you prefer inline SVG component use: 
// import { ReactComponent as InnovaLogoLight } from 'src/svgs/InnovaLogoLight.svg';
// Logo replaced with webp image
import { debugQuickLogin, getPortfolioTokens } from 'src/lib/neuroexchangeApi';
import { createAmountFormater } from 'src/lib/formating';

export default function Nav() {
  const { t, i18n } = useTranslation('common');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const accountContext = useAccount();
  const theme = useTheme();
  const prevScrollY = useRef(0);
  const [isScrollingDown, setIsScrollingDown] = useState(false);
  const [lastY, setLastY] = useState(0);
  const [isWalletTopUpOpen, setWalletTopUpOpen] = useState(false);
  const [isDropdownOpen, setDropdownOpen] = useState(null);
  const [isLogoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const { locale, toggleLocale } = useLocale();
  const cart = useCart();
  const { eventEmitter: emitter } = useEvents();
  const [cartAnchor, setCartAnchor] = useState(null);
  const [cartAutoOpened, setCartAutoOpened] = useState(false);
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const openCartMenu = (anchorEl) => setCartAnchor(anchorEl);
  const closeCartMenu = () => setCartAnchor(null);
  useEffect(() => {
    async function run() {
      try {
        
        //await debugQuickLogin();
        const res = await getPortfolioTokens();
        setTokens(res.tokens || []);
        console.log(res);
        console.log("tokens", tokens);

      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    }
    // run(); // dont run for now since tokens dont do anythin
  }, []);


  useEffect(() => {
    const handleCartUpdated = () => {
      // auto open cart for a brief preview if closed
      if (!cartAnchor) {
        setCartAutoOpened(true);
        setCartAnchor(document.getElementById('nav-cart-button'));
        setTimeout(() => {
          if (setCartAutoOpened) {
            setCartAnchor(null);
            setCartAutoOpened(false);
          }
        }, 3000);
      }
    };
    emitter.on('cartUpdated', handleCartUpdated);
    return () => emitter.off('cartUpdated', handleCartUpdated);
  }, [cartAnchor, emitter]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      if (scrollY > prevScrollY.current) {
        if (scrollY > lastY + 200) setIsScrollingDown(true);
      } else if (scrollY < prevScrollY.current) {
        setLastY(scrollY);
        setIsScrollingDown(false);
      }
      prevScrollY.current = scrollY;
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastY]);

  // Lock body scroll when mobile menu is open to prevent page showing
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = previousOverflow || '';
    }
    return () => {
      document.body.style.overflow = previousOverflow || '';
    };
  }, [mobileMenuOpen]);

  const handleOpenDropdown = (event) => setDropdownOpen(event.currentTarget);
  const handleCloseDropdown = () => setDropdownOpen(null);

  const handleLogoutClick = () => setLogoutDialogOpen(true);
  const handleLogoutConfirm = () => {
    accountContext.logout();
    setLogoutDialogOpen(false);
    window.location.assign('/');
  };
  const handleLogoutCancel = () => setLogoutDialogOpen(false);

  const navLinks = [
    { label: t('nav.allProjects'), to: '/explore' },
    { label: t('nav.about'), to: 'https://innovacrypto.com.br', external: true },
    { label: t('nav.faq'), to: '/faq' },
  ];


  return (
    <>
      <div
        className={`desktop-top ${isScrollingDown ? "" : "show-nav"}`}
        style={{
          position: 'fixed',
          top: 0,
          left: '50%',
          width: '100%',
          zIndex: 30,
          background: '#DFE1E3',
        }}
      >
        {/* Legendary glassy animated nav background */}
        <motion.div
          initial={{ opacity: 0, y: -24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, type: 'spring', stiffness: 70 }}
          className="nav-glass-bg"
        >
          {/* Brazil SVG accent, floating left */}
          <div className="nav-brazil-accent nav-brazil-accent-left">
            <BrazilAccentSVG style={{ width: 44, height: 44, opacity: 0.18 }} />
          </div>
          {/* Brazil SVG accent, floating right */}
          <div className="nav-brazil-accent nav-brazil-accent-right">
            <BrazilAccentSVG style={{ width: 44, height: 44, opacity: 0.13 }} />
          </div>

        </motion.div>
        <nav
          className="nav"
          style={{
            position: 'relative',
            zIndex: 2,
            background: 'transparent',
            minHeight: 64,
            display: 'flex',
            alignItems: 'center',
            padding: '0 2.5vw',
          }}
          aria-label="Main navigation"
        >
          {/* Hamburger for mobile */}
          <IconButton className="nav-mobile-menu-btn" sx={{ display: { xs: 'inline-flex', md: 'none' }, mr: 2 }} onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label={t('aria.openMenu')}>
            <IoMenu size={28} />
          </IconButton>
          <Link to={'/'} style={{ display: 'flex', alignItems: 'center', position: 'relative', marginRight: 18 }}>
            <img src={process.env.PUBLIC_URL + '/images/Innova Crypto logo dark.png'} alt={t('aria.logoAlt')} style={{ height: 64, maxWidth: 220, display: 'block', objectFit: 'contain' }} />
          </Link>

          <nav className="top-nav">
            {navLinks.map((link) =>
              link.external ? (
                <a
                  key={link.to}
                  href={link.to}
                  className="top-nav-link top-nav-link-external"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="nav-link-label">{link.label}</span>
                  <span className="external-icon" aria-hidden="true">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M14 5h5v5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M10 14l9-9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M19 14v5H5V5h5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                </a>
              ) : (
                <Link key={link.to} to={link.to} className="top-nav-link">
                  {link.label}
                </Link>
              )
            )}
          </nav>
          {/* Mobile menu overlay */}
          <AnimatePresence>
            {mobileMenuOpen && (
              <motion.div
                className="nav-mobile-menu"
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.25 }}
                style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100dvh', background: 'rgba(255,255,255,0.98)', zIndex: 100, display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: 64, overflowY: 'auto', overscrollBehavior: 'contain', touchAction: 'pan-y' }}
                onClick={() => setMobileMenuOpen(false)}
              >
                <IconButton sx={{ position: 'absolute', top: 18, right: 18 }} onClick={() => setMobileMenuOpen(false)} aria-label={t('aria.closeMenu')}>
                  <IoClose size={28} />
                </IconButton>
                <Stack gap={2} sx={{ mt: 4, width: '80%', maxWidth: 520, alignItems: 'center' }} onClick={(e) => e.stopPropagation()}>
                  {navLinks.map((link) => (
                    <Button key={link.to} component={Link} to={link.to} onClick={() => setMobileMenuOpen(false)} sx={{ fontSize: 18, fontWeight: 700, width: '64%' }}>{link.label}</Button>
                  ))}
                  <Button component={Link} to={'/portfolio'} onClick={() => setMobileMenuOpen(false)} sx={{ fontSize: 18, fontWeight: 700, width: '64%' }}>{t('nav.portfolio')}</Button>
                  <Button
                    component={Link}
                    to={'/checkout'}
                    onClick={() => setMobileMenuOpen(false)}
                    sx={{ fontSize: 18, fontWeight: 700, width: '64%' }}
                  >
                    {t('nav.checkout')}
                  </Button>
                  <Button onClick={() => { toggleLocale(); }} sx={{ fontSize: 18, fontWeight: 700, width: '64%' }}>{locale === 'pt-BR' ? 'EN-US' : 'PT-BR'}</Button>
                  {!(accountContext.isLoggedIn || accountContext.isQuickLoggedIn) && (
                    <>
                      <Button component={Link} to={'/auth'} onClick={() => setMobileMenuOpen(false)} sx={{ fontSize: 18, fontWeight: 700, width: '64%' }}>{t('nav.login')}</Button>
                      <Button component={Link} to={'/auth?start=1'} onClick={() => setMobileMenuOpen(false)} sx={{ fontSize: 18, fontWeight: 700, width: '64%' }}>{t('nav.getStarted')}</Button>
                    </>
                  )}
                  {(accountContext.isLoggedIn || accountContext.isQuickLoggedIn) && (
                    <Button onClick={() => { handleLogoutClick(); setMobileMenuOpen(false); }} sx={{ fontSize: 18, fontWeight: 700, width: '64%' }}>{t('nav.logout')}</Button>
                  )}
                </Stack>
              </motion.div>
            )}
          </AnimatePresence>

          <Stack flexDirection="row" alignItems="center" gap={2} className="nav-desktop-actions">
            {/* Mobile menu overlay */}
            <AnimatePresence>
              {mobileMenuOpen && (
                <motion.div
                  className="nav-mobile-menu"
                  initial={{ opacity: 0, y: -20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.25 }}
                  style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100dvh', background: 'rgba(255,255,255,0.98)', zIndex: 100, display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: 64, overflowY: 'auto', overscrollBehavior: 'contain', touchAction: 'pan-y' }}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <IconButton sx={{ position: 'absolute', top: 18, right: 18 }} onClick={() => setMobileMenuOpen(false)} aria-label={t('aria.closeMenu')}>
                    <IoClose size={28} />
                  </IconButton>
                  <Stack gap={2} sx={{ mt: 4, width: '80%', maxWidth: 520, alignItems: 'center' }} onClick={(e) => e.stopPropagation()}>
                    {navLinks.map((link) => (
                      <Button key={link.to} component={Link} to={link.to} onClick={() => setMobileMenuOpen(false)} sx={{ fontSize: 18, fontWeight: 700, width: '64%' }}>{link.label}</Button>
                    ))}
                    <Button component={Link} to={'/portfolio'} onClick={() => setMobileMenuOpen(false)} sx={{ fontSize: 18, fontWeight: 700, width: '64%' }}>{t('nav.portfolio')}</Button>
                    <Button
                      component={Link}
                      to={'/checkout'}
                      onClick={() => setMobileMenuOpen(false)}
                      sx={{ fontSize: 18, fontWeight: 700, width: '64%' }}
                    >
                      {t('nav.checkout')}
                    </Button>
                    <Button onClick={() => { toggleLocale(); }} sx={{ fontSize: 18, fontWeight: 700, width: '64%' }}>{locale === 'pt-BR' ? 'EN-US' : 'PT-BR'}</Button>
                    {/* {accountContext.username && (
                                <Typography  aria-label='Logged in user'>Olá, {accountContext.username}</Typography>
                              )} */}
                    {!(accountContext.isLoggedIn || accountContext.isQuickLoggedIn) && (
                      <>
                        <Button component={Link} to={'/auth'} onClick={() => setMobileMenuOpen(false)} sx={{ fontSize: 18, fontWeight: 700, width: '64%' }}>{t('nav.login')}</Button>
                        <Button component={Link} to={'/auth?start=1'} onClick={() => setMobileMenuOpen(false)} sx={{ fontSize: 18, fontWeight: 700, width: '64%' }}>{t('nav.getStarted')}</Button>
                      </>
                    )}
                    {(accountContext.isLoggedIn || accountContext.isQuickLoggedIn) && (
                      <Button onClick={() => { handleLogoutClick(); setMobileMenuOpen(false); }} sx={{ fontSize: 18, fontWeight: 700, width: '64%' }}>{t('nav.logout')}</Button>
                    )}
                  </Stack>
                </motion.div>
              )}
            </AnimatePresence>
            {/* Cart Icon with placeholder to prevent layout shift when clearing */}
            <AnimatePresence initial={false}>
              {cart.cartItems.length > 0 ? (
                <motion.div
                  key="cart-icon"
                  initial={{ opacity: 0, scale: 0.85 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.85 }}
                  style={{ display: 'flex' }}
                >
                  <Tooltip title={t('nav.viewCart')} arrow>
                    <Box sx={{ borderRadius: '0.75rem', background: '#e8f2eb', p: 0.5, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <IconButton
                        id="nav-cart-button"
                        aria-label={`${cart.cartItems.length} items in cart`}
                        aria-haspopup="true"
                        onClick={(e) => openCartMenu(e.currentTarget)}
                        size="medium"
                        sx={{ position: 'relative', background: 'transparent' }}
                      >
                        <Badge badgeContent={cart.cartItems.length} color="primary" overlap="rectangular" sx={{ '& .MuiBadge-badge': { bgcolor: '#0d6854', color: '#fff' } }}>
                          <IoCartOutline size={26} color="#104a3b" />
                        </Badge>
                      </IconButton>
                    </Box>
                  </Tooltip>
                </motion.div>
              ) : (
                <motion.div
                  key="cart-placeholder"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 0 }}
                  exit={{ opacity: 0 }}
                  style={{ width: 48, height: 48 }}
                  aria-hidden="true"
                />
              )}
            </AnimatePresence>
            <motion.button
              onClick={toggleLocale}
              className="legendary-locale-btn"
              whileHover={{ scale: 1.08 }}
              whileTap={{ scale: 0.92 }}
              aria-label={locale === 'pt-BR' ? t('aria.toggleLocaleToEn') : t('aria.toggleLocaleToPt')}
              style={{ fontWeight: 700, fontSize: '0.98rem', padding: '7px 14px', borderRadius: 8 }}
            >
              {locale === 'pt-BR' ? 'EN-US' : 'PT-BR'}
            </motion.button>
            {!(accountContext.isLoggedIn || accountContext.isQuickLoggedIn) && (
              <div className="nav-auth-actions">
                <Link className="nav-auth-login" to="/auth">{t('nav.login')}</Link>
                <Link className="nav-auth-start" to="/auth?start=1">{t('nav.getStarted')}</Link>
              </div>
            )}
            {/* Logged in / quick logged in state */}
            {(accountContext.isLoggedIn || accountContext.isQuickLoggedIn) && (
              <>
                {accountContext.username && (
                  <Typography
                    variant='body2'
                    sx={{
                      fontWeight: 600,
                      color: '#fff',
                      background: 'linear-gradient(90deg,#1e242a 0%,#3a4a5a 100%)',
                      borderRadius: '8px',
                      px: 1.2,
                      py: 0.5,
                      boxShadow: '0 2px 8px -2px rgba(0,0,0,0.12)',
                      display: 'inline-block',
                    }}
                    aria-label={t('aria.loggedInUser')}
                  >
                    {t('nav.hello')}, {accountContext.username}
                  </Typography>
                )}
                <Tooltip title={t('nav.accountMenu')} arrow>
                  <IconButton onClick={handleOpenDropdown} className="legendary-account-btn">
                    <IoPersonSharp size={25} />
                  </IconButton>
                </Tooltip>
                <Menu anchorEl={isDropdownOpen} open={Boolean(isDropdownOpen)} onClose={handleCloseDropdown}>
                  {accountContext.username && (
                    <MenuItem style={{ opacity: 0.85 }}>@{accountContext.username}</MenuItem>
                  )}
                  {/* <MenuItem disabled>
                    {t('nav.balance')}: {accountContext.balance.amount} {accountContext.balance.currency || 'Neuro-Credits'}
                  </MenuItem> */}

                  <MenuItem component={Link} to={'/portfolio'} onClick={handleCloseDropdown}>
                    <IoBarChartOutline size={20} style={{ marginRight: 8 }} />
                    {t('nav.portfolio')}
                  </MenuItem>
                  <MenuItem onClick={handleLogoutClick} sx={{ color: '#111827' }}>{t('nav.logout')}</MenuItem>
                </Menu>
                {/* <WalletTopUp open={isWalletTopUpOpen} onClose={handleCloseWalletTopUp} /> */}
              </>
            )}
            {/* Cart Menu (opens only when there are items) */}
            <Menu
              anchorEl={cartAnchor}
              open={Boolean(cartAnchor)}
              onClose={closeCartMenu}
              MenuListProps={{ 'aria-labelledby': 'nav-cart-button' }}
              PaperProps={{
                sx: {
                  p: 0,
                  mt: 1.5,
                  borderRadius: 2,
                  minWidth: 340,
                  border: '1px solid #dbe5de',
                  boxShadow: '0 22px 60px rgba(24, 58, 41, .16)',
                  overflow: 'hidden',
                  '& .MuiMenu-list': { p: 0 },
                  bgcolor: '#fff',
                },
              }}
            >
              {/* Header */}
              <Box sx={{ px: 2.4, pt: 2, pb: 1.2, borderBottom: '1px solid', borderColor: '#dbe5de' }}>
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 750, fontSize: 16, color: '#18352e', letterSpacing: '-.02em' }}
                >
                  {t('nav.cartTitle') || 'Your cart'}
                </Typography>
              </Box>

              {/* Empty state */}
              {cart.cartItems.length === 0 && (
                <Box sx={{ px: 2.4, py: 2 }}>
                  <Typography variant="body2" sx={{ color: '#60766b', mb: 0.5 }}>
                    {t('nav.cartEmpty')}
                  </Typography>
                  <Typography variant="caption" sx={{ color: '#73887c' }}>
                    {t('nav.emptyActionBrowse')}
                  </Typography>
                </Box>
              )}

              {/* Items */}
              {cart.cartItems.length > 0 && (
                <Box sx={{ maxHeight: 260, overflowY: 'auto', px: 2.4, py: 1.2 }}>
                  <AnimatePresence initial={false}>
                    {cart.cartItems.map((item) => (
                      <Box
                        key={item.id}
                        component={motion.div}
                        initial={{ opacity: 0, x: 8 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: 0 }}
                        transition={{ duration: 0.2 }}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1.5,
                          py: 1.1,
                          borderBottom: '1px solid',
                          borderColor: '#dbe5de',
                          '&:last-of-type': { borderBottom: 'none' },
                        }}
                      >
                        {/* Name + price */}
                        <Box sx={{ flex: '1 1 0', minWidth: 0 }}>
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: 600,
                              lineHeight: 1.3,
                              color: '#18352e',
                              fontSize: 13,
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {item.displayName}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{ color: '#60766b', fontSize: 12, mt: 0.25, display: 'block' }}
                          >
                            {createAmountFormater(item.currency, i18n.language)((Number(item.value || 0) + Number(item.premium || 0)))}
                          </Typography>
                        </Box>

                        {/* Quantity control – pill with - qty + */}
                        {/*
                        <Box
                          sx={{
                            display: 'inline-flex',
                            alignItems: 'stretch',
                            borderRadius: 999,
                            border: '1px solid #E5E7EB',
                            overflow: 'hidden',
                            height: 32,
                            bgcolor: '#F3F4F6', // grey background
                          }}
                          aria-label={`${t('nav.quantity')} ${t('aria.controls')}`}
                        >
                          <IconButton
                            size="small"
                            aria-label={t('aria.decreaseQuantity') || 'Decrease quantity'}
                            onClick={() => cart.updateItemCount(item.id, item.count - 1)}
                            disabled={item.count <= 1}
                            sx={{
                              borderRight: '1px solid #E5E7EB',
                              borderRadius: 0,
                              width: 32,
                              height: 32,
                              color: '#9CA3AF', // grey icon
                            }}
                          >
                            <IoRemove size={14} />
                          </IconButton>
                          <Box
                            sx={{
                              px: 1,
                              minWidth: 24,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <Typography
                              variant="caption"
                              sx={{ fontWeight: 600, fontSize: 12, color: '#111827' }}
                            >
                              {item.count}
                            </Typography>
                          </Box>
                          <IconButton
                            size="small"
                            aria-label={t('aria.increaseQuantity')}
                            onClick={() => cart.updateItemCount(item.id, item.count + 1)}
                            sx={{
                              borderLeft: '1px solid #E5E7EB',
                              borderRadius: 0,
                              width: 32,
                              height: 32,
                              color: '#9CA3AF', // grey icon
                            }}
                          >
                            <IoAdd size={14} />
                          </IconButton>
                        </Box>
                        */}
                        {/* Remove icon (trash-style) */}
                        <IconButton
                          size="small"
                          aria-label={t('nav.remove')}
                          onClick={() => cart.removeFromCart(item)}
                          sx={{
                            ml: 0.5,
                            width: 32,
                            height: 32,
                            borderRadius: 1.5,
                            bgcolor: '#eaf2ed',
                            color: '#60766b',
                            '&:hover': {
                              bgcolor: '#dbe5de',
                              color: '#104a3b',
                            },
                          }}
                        >
                          {/* You can swap to a real trash icon if you want */}
                          <IoTrashOutline size={14} />
                        </IconButton>
                      </Box>
                    ))}
                  </AnimatePresence>
                </Box>
              )}

              {/* Footer – subtotal + total + CTA */}
              {cart.cartItems.length > 0 && (
                <>
                  <Divider sx={{ borderColor: '#dbe5de' }} />
                  <Box sx={{ px: 2.4, py: 1.6, bgcolor: '#f7faf7' }}>
                    <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.5 }}>
                      <Typography variant="caption" sx={{ fontSize: 12, color: '#60766b' }}>
                        {t('nav.subtotal') || 'Subtotal'}
                      </Typography>
                      <Typography variant="caption" sx={{ fontSize: 12, color: '#60766b' }}>
                        {createAmountFormater(cart.cartItems[0].currency, i18n.language)(cart.totalCost)}
                      </Typography>
                    </Stack>

                    <Stack direction="row" justifyContent="space-between" sx={{ mb: 1.25 }}>
                      <Typography variant="body2" sx={{ fontWeight: 600, fontSize: 13, color: '#18352e' }}>
                        {t('nav.total') || 'Total'}
                      </Typography>
                      <Typography variant="body2" sx={{ fontWeight: 700, fontSize: 14, color: '#18352e' }}>
                        {createAmountFormater(cart.cartItems[0].currency, i18n.language)(cart.totalCost)}
                      </Typography>
                    </Stack>

                    <Button
                      fullWidth
                      variant="contained"
                      sx={{
                        mt: 0.5,
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 700,
                        fontSize: 14,
                        py: 1.1,
                        bgcolor: '#104a3b',
                        color: '#fff',
                        boxShadow: 'none',
                        '&:hover': { bgcolor: '#173a30', boxShadow: 'none' },
                      }}
                      onClick={() => {
                        closeCartMenu();
                        !(accountContext.isLoggedIn || accountContext.isQuickLoggedIn)
                          ? (() => {
                            try { cart.markPendingCheckout?.(); } catch (e) {
                              // ignore storage errors
                            }
                            window.location.href = '/auth';
                          })()
                          : (window.location.href = '/checkout');
                      }}
                    >
                      {!(accountContext.isLoggedIn || accountContext.isQuickLoggedIn)
                        ? t('nav.loginToCheckout')
                        : t('nav.checkout') || 'Go to checkout'}
                    </Button>
                  </Box>
                </>
              )}

              {/* aria-live region announcing total updates */}
              <Box
                sx={{
                  position: 'absolute',
                  width: 1,
                  height: 1,
                  overflow: 'hidden',
                  clip: 'rect(0 0 0 0)',
                  whiteSpace: 'nowrap',
                }}
                aria-live="polite"
                role="status"
              >
                {t('nav.total')}: {createAmountFormater(cart.cartItems[0]?.currency, i18n.language)(cart.totalCost)}
              </Box>
            </Menu>
          </Stack>
          {/* Optional: Trust ticker or badge slot for extra delight */}
          {/* <div className="legendary-trust-ticker"><LiveTrustTicker /></div> */}
        </nav>
      </div>
      <Dialog open={isLogoutDialogOpen} onClose={handleLogoutCancel} aria-labelledby="logout-dialog-title" aria-describedby="logout-dialog-description">
        <DialogTitle id="logout-dialog-title">{t('nav.confirmLogoutTitle')}</DialogTitle>
        <DialogContent>
          <DialogContentText id="logout-dialog-description">{t('nav.confirmLogoutDesc')}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogoutCancel} variant="contained" color="primary">{t('nav.cancel')}</Button>
          <Button onClick={handleLogoutConfirm} variant="contained" color="primary" autoFocus>{t('nav.logout')}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
